import { forwardRef, useCallback } from "react";
import { GridRenderCellParams, useGridRootProps } from "@mui/x-data-grid-pro";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";
import { IGroupedWaitingRoom } from "src/Pages/Company/Pending/PendingBenefits/types";

export const CustomCellCheckbox = forwardRef<
  HTMLInputElement,
  GridRenderCellParams<IGroupedWaitingRoom>
>((props, ref) => {
  const {
    field,
    id,
    formattedValue,
    row,
    rowNode,
    colDef,
    isEditable,
    cellMode,
    hasFocus,
    api,
    ...other
  } = props;
  const rootProps = useGridRootProps();

  const { getRowState, handleSelectRow } = useSelectedRows();
  const { isChecked, isIndeterminate } = getRowState(row);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleSelectRow(row, event.target.checked);
    },
    [handleSelectRow, row]
  );

  if (rowNode.type === "footer" || rowNode.type === "pinnedRow") {
    return null;
  }

  return (
    <rootProps.slots.baseCheckbox
      checked={isChecked && !isIndeterminate}
      onChange={handleChange}
      indeterminate={isIndeterminate}
      {...rootProps.slotProps?.baseCheckbox}
      {...other}
      ref={ref as never}
    />
  );
});
